import { render, staticRenderFns } from "./biodataDetile.vue?vue&type=template&id=bffa402c&scoped=true&"
import script from "./biodataDetile.vue?vue&type=script&lang=js&"
export * from "./biodataDetile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffa402c",
  null
  
)

export default component.exports